import React, { useState } from "react";

import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

import { faPlusCircle, faBox } from "@fortawesome/free-solid-svg-icons";

import Button from "../../UI/Button/Button";
import Headline from "../../Headline/Headline";
import CreateUser from "./CreateUser/CreateUser";
import Card from "../../UI/Card/Card";
import RegisterDeveloper from "../Profile/RegisterDeveloper";
import CloseOnSuccessModalWizard, { ModalSize } from "../../UI/Modal/CloseOnSuccessModalWizard";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "SANDBOX_PROFILE";

/* !! Design Deprecated*/

const SandBoxProfile = (props) => {
    const intl = useIntl();
    const user = useSelector(state => state.sandBoxContacts.user);
    const [modal, setModal] = useState();

    const handleShowCreateUserModal = () => {
        LogService.trace(LOG_TAG, "handleShowCreateUserModal");

        const getComponent = (handleOnSuccess, handleOnFailed) => {
            return (
                <CreateUser
                    title={intl.messages.sandBoxProfileCreateUserButton}
                    emailPlaceholder={intl.messages.sandBoxProfileCreateUserEmailPlaceholder}
                    isSandBox={true}
                    onActionSuccess={() => handleOnSuccess()}
                    onActionFailed={() => handleOnFailed(intl.messages.sandBoxProfileCreateUserFailedMessage)}
                />
            );
        }
        setModal(
            <CloseOnSuccessModalWizard
                title={intl.messages.sandBoxProfileCreateUserButton}
                icon={faBox}
                iconColor="green"
                getComponent={getComponent}
                modalSize={ModalSize.Small}
            />
        );
    };

    LogService.trace(LOG_TAG, "render", user);
    // let isAdmin = ContactUtils.isCompanyAdmin(user);
    let isAdmin = false;

    let displaycontent =
        <Card header={false}>
            <p>Not authenticated on SandBox</p>
        </Card>;

    if (user) {
        displaycontent =
            <div className="mt-5">
                {isAdmin &&
                    <Button
                        className="btn-submit mb-3"
                        label={intl.messages.sandBoxProfileCreateUserButton}
                        icon={faPlusCircle}
                        onClick={handleShowCreateUserModal}
                    />
                }
                <RegisterDeveloper isSandBox={true} />
            </div>
    }

    return (
        <div>
            <Headline
                title={intl.messages.sandBoxProfileTitle}
                subtitle={intl.messages.sandBoxProfileSubTitle}
            />

            <div className="row card">
                {modal}
                {displaycontent}
            </div>
        </div>
    );
}

export default SandBoxProfile;